import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: 8,
  gap: 14,
  justifyContent: 'space-between',
  alignItems: 'center',
  border: `1px solid ${spaceCadet[100]}`,
  borderRadius: 6,
  '& > .MuiBox-root': {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    '& > .MuiTypography-subtitle2': {
      fontSize: 14,
      fontWeight: 600,
      maxWidth: 200,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .MuiButton-text': {
      padding: 0,
      color: ultraMarine[500],
      textDecoration: 'underline',
      textTransform: 'none',
      minWidth: 32,
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '18px',
      '&:hover': {
        backgroundColor: 'transparent',
        color: ultraMarine[700],
      },
    },
    '& .point': {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 600,
      color: spaceCadet[400],
    },
    '& .MuiTypography-caption': {
      color: spaceCadet[400],
      fontWeight: 600,
      fontSize: 14,
      minWidth: 40,
    },
  },
  '& .MuiButton-root': {
    padding: theme.spacing(0.5, 1),
    minHeight: 0,
    color: ultraMarine[500],
    textTransform: 'none',
    fontSize: 12,
    lineHeight: 1.25,
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },

}));

export default StyledBox;
